import React, { useEffect, useState } from "react";
import Header from "../../Header";
import * as commonData from "../../Common";
import { AgGridReact } from "ag-grid-react";
import AgGridComponent from "../tattle/agGridComponent";
import { useDispatch } from "react-redux";
import { checkLinkForSideMenu } from "../../Actions/checkLinkForSideMenu";
import { Container } from "react-bootstrap";

const Customers = (props) => {
  const apiurl = commonData.commonData().apiUrl;
  const dispatch = useDispatch();
  const [state, setState] = useState({
    customerColumns: [
      // {
      //   headerName: "Name",
      //   field: "name",
      //   sortable: true,
      //   wrapText: true,
      //   autoHeight: true,
      //   resizable: true,
      //   flex: 1,
      //   cellRenderer: (val) => {
      //     console.log(val, 5456213);
      //     return (
      //       <span>
      //         <img
      //           src={val.data.profile_image}
      //           style={{ borderRadius: "50px", width: "30px" }}
      //         />
      //         &nbsp;
      //         {val.data.name}
      //       </span>
      //     );
      //   },
      // },
      {
        headerName: "Company Name",
        field: "company_name",
        sortable: true,
        wrapText: true,
        autoHeight: true,
        resizable: true,
        flex: 1,
      },
      {
        headerName: "Customer Type",
        field: "customer_type",
        sortable: true,
        wrapText: true,
        autoHeight: true,
        resizable: true,
        flex: 1,
      },
    ],
    filteredList: [],
    customerSearch: "",
    gridApi: "",
    gridColumnApi: "",
    commondata: "",
  });
  useEffect(() => {
    document.title = `Tattle | ${props.title}`;
    const data = commonData.getCommonData();
    setState((state) => {
      return {
        ...state,
        commondata: { ...data },
      };
    });
    dispatch(checkLinkForSideMenu("customers"));
  }, []);

  const onFilterTextBoxChanged = (val) => {
    state.gridApi.setQuickFilter(val);
  };
  const onGridReady = (params) => {
    (async () => {
      const customerData = [];
      params.api.showLoadingOverlay();
      const resp = await fetch(`${apiurl}get-customer-list`, {
        method: "post",
        body: JSON.stringify({ app_token: state.commondata.app_token }),
      });
      const resData = await resp.json();
      if (resData) {
        Object.keys(resData).map((item) => {
          customerData.push({
            name: resData[item]?.name,
            email: resData[item]?.email,
            no_of_tattle: resData[item]?.no_of_tattle,
            profile_image: resData[item]?.profile_image,
            customer_type: resData[item]?.customer_type,
            company_name: resData[item]?.company_name,
          });
        });
        setState((newState) => {
          return {
            ...newState,
            filteredList: customerData,
          };
        });
      } else {
        params.api.showNoRowsOverlay();
      }
    })();
    setState((state) => {
      return {
        ...state,
        gridApi: params.api,
        gridColumnApi: params.columnApi,
      };
    });
  };
  const filterlist = state.filteredList.filter((item) => {
    return (item?.name || item?.email)
      ?.toLowerCase()
      .includes(state.customerSearch?.toLowerCase());
  });

  return (
    <div class="mainContent-panel-wrap" style={{ overflow: "auto" }}>
      <Header brecum_name={{ name: "", link: "" }} brecum_page={props.title} />
      <Container fluid>
        <div class="page-content pt-3 new-content-main">
          <div class="card cardTable">
            <div class="card-body border-bottom mail-box">
              <div class="p-2 ps-3 border-bottom">
                <div class="row gx-2 justify-content-end align-items-center">
                  <div class="col">
                    <div class="title px-1">Customers</div>{" "}
                  </div>

                  <div class="col-3">
                    <div class="searchBox border">
                      <div class="input-group">
                        <input
                          type="text"
                          id="filter-text-box"
                          class="form-control ps-0"
                          placeholder=" Search"
                          onChange={(evt) => {
                            onFilterTextBoxChanged(evt.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ flex: 1, height: 500 }}>
                <AgGridComponent
                  data={filterlist}
                  columns={state.customerColumns}
                  onGridReady={onGridReady}
                  cacheQuickFilter={true}
                  paginationPageSize={10}
                  overlayLoadingTemplate={
                    '<span className="ag-overlay-loading-center">Loading...</span>'
                  }
                  overlayNoRowsTemplate={
                    '<span className="ag-overlay-loading-center">No data found.</span>'
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Customers;
